import React from 'react';
import { Button } from '../';
import PropTypes from 'prop-types';

const GA_CATEGORY = 'Header Menu';

const GetQuotesButton = Button.extend`
  padding: 6px 15px;

  font-size: 13px;
  line-height: 24px;
  font-weight: 500;

  @media (min-width: 1008px) {
    padding: 6px 19px;
  }
`;

const GQButton = ({ siteSource }) => (
  <GetQuotesButton
    tag="a"
    primary
    href="/get_quotes_simple"
    data-ga-category={GA_CATEGORY}
    data-ga-action={`${GA_CATEGORY} - Clicked Get Quotes`}
    data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
    data-label={'header-get-quotes'}
  >
    Get Quotes
  </GetQuotesButton>
);

GQButton.propTypes = {
  siteSource: PropTypes.string
};

export default GQButton;
